import { Cell } from '@pelckmans/elementis/components/table';
import TimeIcon from '@pelckmans/elementis/icons/time';
import { ComponentProps } from 'react';
import { formatDuration } from '../../../../../../utils/results';

export default function TimeCell({
  duration,
  highlighted,
}: { duration?: number } & Pick<ComponentProps<typeof Cell>, 'highlighted'>) {
  const durationStr = duration ? formatDuration(duration) : '';

  return (
    <Cell highlighted={highlighted} minWidth="sm" maxWidth="sm">
      {duration ? <Cell.Text title={durationStr} startAdornment={<TimeIcon data-testid="time-icon" />} /> : null}
    </Cell>
  );
}
